import type { AnalysesLpuCardsFilters } from 'src/components/pages/[town-translit]/diagnostika/analiz/api/apiAnalysesLpuCardsFilter.types'
import type { ApiAnalysesLpuListCountParams } from 'src/components/pages/[town-translit]/diagnostika/analiz/api/apiAnalysesLpuListCount.types'
import { ANALYSES_LPU_DEFAULT_SORT } from 'src/components/pages/[town-translit]/diagnostika/analiz/_constants/analyses-lpu-sort'

export function buildAnalysesLpuListCountParams(
  filters: AnalysesLpuCardsFilters,
  townId: number,
): ApiAnalysesLpuListCountParams {
  const params: ApiAnalysesLpuListCountParams = {
    town_id: townId,
  }

  if (filters.sort && filters.sort !== ANALYSES_LPU_DEFAULT_SORT) {
    params.sort = filters.sort
  }

  if (filters.onlineOrder) {
    params.online_order = true
  }

  if (filters.withDiscount) {
    params.order_discount = true
  }

  if (filters.place?.id) {
    if (filters.place.isMetro) {
      params.metro_id = filters.place.id
    } else {
      params.district_id = filters.place.id
    }
  }

  return params
}
